import { configureStore } from '@reduxjs/toolkit';
import projectReducer from './slices/projectSlice';
import areaReducer from './slices/areaSlice';
import authReducer from './slices/authSlice';
import siteReducer from 'slices/siteSlice';
import binReducer from 'slices/binSlice';
import stillageWidgetModalReducer from 'slices/stillageWidgetModalSlice';
import stillageCollections from 'slices/stillageCollections';
import glassSearchReducer from 'slices/glassSearchSlice';
import otifSliceReducer from 'slices/glassDashboard/otifSlice';
import coqSliceReducer from 'slices/glassDashboard/coqSlice';
import coqYearSliceReducer from 'slices/glassDashboard/coqYearSlice';
import remakeSliceReducer from 'slices/glassDashboard/remakeslice';
import backlogSliceReduer from 'slices/glassDashboard/backlogSlice';
import bitSliceReducer from 'slices/glassDashboard/bitSlice';
import shelledSliceReducer from 'slices/glassDashboard/shelledSlice';
import glassDataModalReducer from 'slices/glassDashboard/glassDataModalSlice';
import totalsReducer from 'slices/glassDashboard/totalsSlice';
import disputeReducer from 'slices/glassDashboard/disputeSlice';
import otherIssuesReducer from 'slices/glassDashboard/otherIssues';
import stillageSliceReducer from 'slices/glassDashboard/stillages';

const store = configureStore({
  reducer: {
    project: projectReducer,
    user: authReducer,
    area: areaReducer,
    site: siteReducer,
    bin: binReducer,
    stillageWidgetModal: stillageWidgetModalReducer,
    stillageCollections: stillageCollections,
    glassSearchFilter: glassSearchReducer,
    otif: otifSliceReducer,
    coq: coqSliceReducer,
    coqYear: coqYearSliceReducer,
    remake: remakeSliceReducer,
    backlog: backlogSliceReduer,
    bit: bitSliceReducer,
    shelled: shelledSliceReducer,
    glassDataModal: glassDataModalReducer,
    glassTotals: totalsReducer,
    glassDisputeSummary: disputeReducer,
    glassOtherIssues: otherIssuesReducer,
    stillage: stillageSliceReducer,
  }
});

export default store;